import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { LoaderService } from './core/services/loader.service';
import { TitleService } from './core/services/title.service';
import { UpdateService } from './core/services/update.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from './shared/services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    public loader: LoaderService,
    private titleService: TitleService,
    private translate: TranslateService,
    private navigationService: NavigationService,
    private updateService: UpdateService
  ) {
    this.translate.addLangs(['fa']);
    this.translate.setDefaultLang('fa');
    this.translate.use('fa');
  }

  ngOnInit(): void {
    this.authService.autoLogin();
    this.titleService.init();
    this.navigationService.init();
    this.updateService.checkForUpdates();
  }
}
